import keyBy from 'lodash/keyBy';
import simplifyFeature from '@turf/simplify';
import simplifyJS from 'simplify-js';

import create, {prepare} from '~/misc/create';
import getAreaAlongPath from '~/misc/getAreaAlongPath';
import * as mapAPI from '~/api/map';
import types from './types';
import * as staticMaps from '~/misc/staticmaps';
import {promiseAction} from '~/misc/dispatch';
import LOADS from './types';
import {loadLocations, loadWeightStation, loadBusiness} from './api';
import { specialLoadsVerify } from '~/api/loads';
import config from '~/config';

const toPair = (item) => [item.x, item.y];
const toXY = (item) => ({x: item[0], y: item[1]});

const simplify = (list, tolerance, highQuality) =>
  simplifyJS(list.map(toXY), tolerance, highQuality).map(toPair);

export const searchResultsToggle = (identity, toggleOrNot) => (dispatch) => {
  if (toggleOrNot) {
    return null;
  }

  return dispatch(create(types.SEARCH_RESULTS_TOGGLE, identity));
};

export const closePremiumToolTip = prepare(types.LOADS_PREMIUM_TOOLTIP_CLOSED);
export const toggleLoadPhone = prepare(types.TOGGLE_LOADPHONE);

export const showBTN = (currentId) => create(types.LOADS_BROKER_SHOW_SIGNLOGIN_BTN, {currentId: currentId});
export const hideBTN = (currentId) => create(types.LOADS_BROKER_HIDE_SIGNLOGIN_BTN, {currentId: currentId});

export const toggleRouteTruckStops = prepare(types.LOADS_TOGGLED_ROUTE_TRUCK_STOPS);
export const toggleRouteWeightStations = prepare(types.LOADS_TOGGLED_ROUTE_WEIGHT_STATIONS);


const getArea = (list, tolerance = 0.08) => {
  if (!list) {
    return null;
  }

  const simple = simplify(list, tolerance, true);
  return simplifyFeature(getAreaAlongPath(simple, 20), tolerance);
};

const loadPath = (load) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  LOADS.SEARCH_RESULTS_STATICMAP_URL_CACHED,
  mapAPI
    .getPolyline(load.from_location, load.to_location)
    .then(({path, polyline}) => {
      const route = path && path.map(item => ({
        lat: item.lat(),
        lng: item.lng(),
      }));

      const data = {
        path: route,
        route: {
          compact: '',//staticMaps.url(load.from_location, load.to_location, 640, 130, polyline),
          mainCol: ''//staticMaps.url(load.from_location, load.to_location, 640, 160, polyline),
        },
      };

      return data;
    }),
  {id: load.id}
);

export const loadRouteRelatedData = (load) => (dispatch, getState) => {
  const route = dispatch(loadPath(load));

  if (!config.poi2) {
    return route;
  }

  const locations = promiseAction(
    dispatch,
    getState,
    LOADS.LOADS_FETCHED_ROUTE_LOCATIONS,
    route.then(resp => {
      const list = resp.path && resp.path.map(({lat, lng}) => [lng, lat]);
      const area = list && getArea(list);
      return loadLocations(area);
    }),
    {id: load.id}
  );

  const indexed = locations.then((list) => {
    const ids = list && list.map(({id}) => id);
    const index = keyBy(list, 'id');

    return {
      index,
      ids,
    };
  });

  const weightStations = promiseAction(
    dispatch,
    getState,
    LOADS.LOADS_FETCHED_ROUTE_WEIGHT_STATIONS,
    indexed.then(({ids, index}) => loadWeightStation(ids).then(
      stations => stations.map(item => ({...item, location: index[item.id].location}))
    )),
    {id: load.id}
  );

  const truckStops = promiseAction(
    dispatch,
    getState,
    LOADS.LOADS_FETCHED_ROUTE_TRUCK_STOPS,
    indexed.then(({ids, index}) => loadBusiness(ids, 'truck_stop').then(
      stations => stations.map(item => ({...item, location: index[item.id].location}))
    )),
    {id: load.id}
  );

  return promiseAction(
    dispatch,
    getState,
    LOADS.LOADS_FETCHED_ROUTE_RELATED_DATA,
    Promise.all([weightStations, truckStops]),
    {id: load.id}
  );
};


const verifyLoads = (id, source) => (dispatch, getState) =>
  promiseAction(
    dispatch,
    getState,
    LOADS.lOADS_VERIFY,
    specialLoadsVerify(getState, id, source)
  );

export const verifyBidLoads = (id) =>  verifyLoads(id, 'BIDS')



// WEBPACK FOOTER //
// ./src/modules/loads/actions.js